import React from 'react';
import type { IconProps } from '../types';

export const SidePanelCloseLeft = (props: IconProps) => (
  <svg
    width="5"
    height="8"
    viewBox="0 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.51074 1.2627L0.760742 4.0127L3.51074 6.7627"
      stroke="white"
      strokeOpacity="0.847059"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SidePanelCloseLeft;
